import {
  createContext as createReactRouterContext,
  RouterContextProvider,
} from 'react-router';

import type { HorizonServerEnv } from '#/../../horizon-server/get-horizon-server-env';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import type { DatetimeString } from '#/types/TypedDateString';
import type { createServerFetchEndpointFn } from '#/utils/endpoint/createServerFetchEndpointFn';
import type { Flash } from '#/zustand-stores/flashesStore';

export type ServerRouterContext = {
  clientIp: string;
  fetchPromises: Record<string, unknown>;
  locale: I18nLocale;
  localeCookieHeader: string | null;
  flash: Flash | null;
  staffSearchLocation: SearchLocation | null;
  horizonServerEnv: HorizonServerEnv;
  hasUseRealGMapsGoogle: boolean;
  hasNoCacheCookie: boolean;
  createServerFetchEndpointFn: typeof createServerFetchEndpointFn;
  hidePtSunsetBanner: boolean;
  now: DatetimeString;
};

/**
 * This context is not exported on purpose.
 *
 * It's used in several places, and it's desirable that we enforce a way to use it,
 * in this case we're enforcing the name `{ serverContext } = getServerRouterContext(...)`
 *
 * Use getServerRouterContext(...) and setServerRouterContext(...)
 */
const serverRouterContext = createReactRouterContext<ServerRouterContext>();

export function getServerRouterContext(
  context: Readonly<RouterContextProvider>,
) {
  return { serverContext: context.get(serverRouterContext) };
}

export function setServerRouterContext(
  context: Readonly<RouterContextProvider>,
  value: ServerRouterContext,
) {
  context.set(serverRouterContext, value);
}
